import "./../styles/index.css";
import routes from "./../route";
import React from "react";
import Navbar from "./../components/Navbar";
import { Switch, Route, Router } from "./../util/router";
import Footer from "./../components/Footer";
import "./../util/analytics";
import { AuthProvider } from "./../util/auth";
import { ThemeProvider } from "./../util/theme";
import { QueryClientProvider } from "./../util/db";
import StoreReferral from "../components/StoreReferral";

function App(props) {
  return (
    <QueryClientProvider>
      <ThemeProvider>
        <AuthProvider>
          <StoreReferral />
          <Router>
            <>
              <Navbar
                color="default"
                logo="/logo.png"
                logoInverted="/logo-inverted.png"
              />

              <Switch>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                  />
                ))}
              </Switch>

              <Footer
                bgColor="default"
                size="medium"
                bgImage=""
                bgImageOpacity={1}
                description="It is the most advanced NSFW Generator. You can create incredibly realistic uncensored AI images using this tool."
                copyright={`© ${new Date().getFullYear()} Company`}
                logo="/logo.png"
                logoInverted="/logo-inverted.png"
                sticky={true}
              />
            </>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
